import { StyleSheet, Dimensions } from 'react-native';
import { Color } from '../../styles';
import { scale } from '../../utils/scale.utils';

const { height, width } = Dimensions.get('window');
const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    //position: 'absolute',
  },
  overlay: {
    width: width,
    height: '100%',
    position: 'absolute',
    backgroundColor: 'rgba(52,52,52,0.5)',
    top: 0,
  },
  contentContainer: {
    maxWidth: '80%',
    borderRadius: 5,
    backgroundColor: 'white',
    padding: 10
  },
  content: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10
  },
  action: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginTop: 5
  },
  title: {
    paddingVertical: 5,
    paddingHorizontal: 15,
    color: '#626262',
    fontSize: 18
  },
  message: {
    paddingTop: 5,
    color: '#7b7b7b',
    fontSize: 14
  },
  button: {
    paddingHorizontal: 10,
    paddingVertical: 7,
    margin: 5,
    borderRadius: 5
  },
  buttonText: {
    color: '#fff',
    fontSize: 13
  },
  closeButton: {
    padding: 0,
    zIndex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',  // Pushes the button to the right
    marginRight: scale(9),
},
  closeButtonText: {
    fontSize: scale(22),
    fontWeight: 'bold',
    color: Color.gray,
    padding: 0,
  }
});

export default styles;
